export function names(arr) {
  return arr.map(({ name }) => name);
}

export function encodeSpaces(f) {
  return f.replace(/\s+/g, 'SPACE');
}

export function decodeSpaces(f) {
  return f.replace(/(SPACE)+/g, ' ');
}

export function getTokens(query, { favouriteMetrics }) {
  return query
    .replace(new RegExp(`(${favouriteMetrics.join('|')})`), encodeSpaces)
    .split(/\s+/)
    .map(decodeSpaces);
}
